module.exports = "<div class=\"fix-router-outlet bg-white\">\n  <div class=\"d-flex flex-1 justify-content-center align-items-center\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/account-layout/account-layout.component.html
// module id = 1146
// module chunks = 0